/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { Suspense, useRef } from 'react'
import { useGLTF } from '@react-three/drei/useGLTF'
import { animated } from 'react-spring/three'
import { Html } from '@react-three/drei';

const MerryMask = () => {
  const { materials, nodes } = useGLTF('/merry-mask.glb');
  return <animated.mesh material={materials['merry']} geometry={nodes.defaultMaterial.geometry} position={[0, 0.8, 0]} />
}

const HoHoMask = () => {
  const { materials, nodes } = useGLTF('/hoho-mask.glb');
  return <animated.mesh material={materials['hoho']} geometry={nodes.defaultMaterial.geometry} position={[0, 0.8, 0]} />
}

const HollyMask = () => {
  const { materials, nodes } = useGLTF('/holly-mask.glb');
  return <animated.mesh material={materials['holly']} geometry={nodes.defaultMaterial.geometry} position={[0, 0.8, 0]} />
}

const MonsterMask = () => {
  const { materials, nodes } = useGLTF('/monster-mask.glb');
  return <animated.mesh material={materials['merry']} geometry={nodes.defaultMaterial.geometry} position={[0, 0.8, 0]} />
}

const ClownMask = () => {
  const { materials, nodes } = useGLTF('/clown-mask.glb');
  return <mesh material={materials['merry']} geometry={nodes.defaultMaterial.geometry} position={[0, 0.8, 0]} />
}

const PumpkinMask = () => {
  const { materials, nodes } = useGLTF('/pumpkin-mask.glb');
  return <animated.mesh material={materials['merry']} geometry={nodes.defaultMaterial.geometry} position={[0, 0.8, 0]} />
}

const getMaskForSelected = (selected) => {
  switch (selected) {
    case 'merry':
      return <Suspense fallback={<Html position={[]}><img alt="mask placeholder" style={{opacity: 0.7}} src="/placeholder-merry.png"></img></Html>}>
        <Straps></Straps>
        <MerryMask></MerryMask>
      </Suspense>
    case 'hoho':
      return <Suspense fallback={<Html position={[]}><img alt="mask placeholder" style={{opacity: 0.7}} src="/placeholder.png"></img></Html>}>
        <Straps></Straps>
        <HoHoMask></HoHoMask>
      </Suspense>
    case 'holly':
      return <Suspense fallback={<Html position={[]}><img alt="mask placeholder" style={{opacity: 0.7}} src="/placeholder-holly.png"></img></Html>}>
      <Straps></Straps>
      <HollyMask></HollyMask>
    </Suspense>
    case 'monster':
      return <Suspense fallback={<Html position={[]}><img alt="mask placeholder" style={{opacity: 0.7}} src="/placeholder-monster.png"></img></Html>}>
      <Straps></Straps>
      <MonsterMask></MonsterMask>
    </Suspense>
    case 'clown':
      return <Suspense fallback={<Html position={[]}><img alt="mask placeholder" style={{opacity: 0.7}} src="/placeholder-clown.png"></img></Html>}>
      <Straps></Straps>
      <ClownMask></ClownMask>
    </Suspense>
    case 'pumpkin':
      return <Suspense fallback={<Html position={[]}><img alt="mask placeholder" style={{opacity: 0.7}} src="/placeholder-pumpkin.png"></img></Html>}>
      <Straps></Straps>
      <PumpkinMask></PumpkinMask>
    </Suspense>
    default:
      return null;
  }
}

const Straps = () => {
  const { materials, nodes } = useGLTF('/strap.glb');
  console.log(materials, nodes);
  return <group rotation={[Math.PI / 2, 0, 0]}>
    <mesh material={materials['material_0']} geometry={nodes.Left_strap.geometry} position={[0,0,0]} />
    <mesh material={materials['material_0']} geometry={nodes.Left_strap.geometry} position={[-1.3,0,0.3]} rotation={[0,0.5,0]}/>
  </group>
}


export default function Model({ selected, position, scale, rotation }) {
  const group = useRef()

  return (
    <group ref={group} position={position} scale={scale}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <animated.group rotation={rotation}>
            { getMaskForSelected(selected) }
          </animated.group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/strap.glb');